import https from 'https'

export default function ({ $axios, app, store }) {
  if (process.env.NODE_ENV === 'development') {
    $axios.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false })
  }
  $axios.onRequest((config) => {
    // debugger
    config.headers['Cache-Control'] =
      'private, no-cache, no-store, must-revalidate'

    if (store.state.token) {
      config.headers.Authorization = `Bearer ${store.state.token}`
    }
  })
}
